export const CURRENCY_FORMAT = {
  KHR: {
    code: 'KHR',
    symbol: '៛',
    thousandFormat: ',',
    decimalDigits: 0,
    exponent: 2,
  },
  IDR: {
    code: 'IDR',
    symbol: 'Rp',
    thousandFormat: '.',
    decimalDigits: 0,
    exponent: 2,
  },
  MYR: {
    code: 'MYR',
    symbol: 'RM',
    thousandFormat: ',',
    decimalDigits: 2,
    exponent: 2,
  },
  MMK: {
    code: 'MMK',
    symbol: 'Ks',
    thousandFormat: ',',
    decimalDigits: 0,
    exponent: 2,
  },
  PHP: {
    code: 'PHP',
    symbol: '₱',
    thousandFormat: ',',
    decimalDigits: 2,
    exponent: 2,
  },
  SGD: {
    code: 'SGD',
    symbol: 'S$',
    thousandFormat: ',',
    decimalDigits: 2,
    exponent: 2,
  },
  THB: {
    code: 'THB',
    symbol: '฿',
    thousandFormat: ',',
    decimalDigits: 0,
    exponent: 2,
  },
  VND: {
    code: 'VND',
    symbol: '₫',
    thousandFormat: '.',
    decimalDigits: 0,
    exponent: 0,
  },
};

export default {};
